import "./App.css";
import RoutesConfig from "./routes";
import ScrollToTop from "./ScrollToTop";
import { NotificationsProvider } from "./components/Notifications/Notifications";
import { motion, AnimatePresence } from "framer-motion";
import { Provider } from 'react-redux';
import store, { persistor } from "./store/store"
import { PersistGate } from 'redux-persist/integration/react';
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NotificationsProvider>
          <div className="App">
            <ScrollToTop />
            <AnimatePresence mode="wait">
                <RoutesConfig />
            </AnimatePresence>
          </div>
        </NotificationsProvider>
      </PersistGate>
    </Provider>
  );
}


export default App;

